/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit GoToPatientProfile/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function GoToPatientProfile({
  children,
  viewPath = "/DesignSystem/LeadPreview/Content/PatientAction/GoToPatientProfile"
  
}) {
let leadPatientIdValueData = fromData.useDataValue({ viewPath,
context: 'lead',
path: 'patient._id',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 type="primary"
 block={true}
 data="lead.patient._id"
 disabled={!leadPatientIdValueData}
 onClick={onClick}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Patient Profile"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}